import { startIdRecording, stopIdRecording } from './ids';
import type { MutationMode } from './registry';

export type MutationEnvelope = { name: string; args: unknown[]; ids: string[] };
export type MutationSink = (envelope: MutationEnvelope) => void;

let activeSink: MutationSink | null = null;
let depth = 0;

export function setMutationSink(sink: MutationSink | null): void {
  activeSink = sink;
}

export function synced<A extends unknown[], R>(
  name: string,
  mode: MutationMode,
  fn: (...args: A) => R,
): (...args: A) => R {
  return (...args: A): R => {
    const sink = activeSink;
    if (sink !== null && mode === 'mockOnly') {
      throw new Error(`Действие «${name}» недоступно в живом режиме`);
    }
    if (sink === null || mode === 'local' || depth > 0) {
      return fn(...args);
    }
    depth += 1;
    startIdRecording();
    try {
      const result = fn(...args);
      sink({ name, args, ids: stopIdRecording() });
      return result;
    } finally {
      stopIdRecording();
      depth -= 1;
    }
  };
}
